import { render, staticRenderFns } from "./notice-view.vue?vue&type=template&id=9e0f8a9e"
import script from "./notice-view.vue?vue&type=script&lang=js"
export * from "./notice-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports